import React from "react";
import Layout from "@app/Layout";
import Canonical from "@shared/head/Canonical";
import Breadcrumbs from "@shared/head/Breadcrumbs";
import { RoleLanding } from "@features/custom-chatbot/RoleLanding";

import {
  heroData,
  featuresHeading,
  features,
  comingSoon,
  finalCta,
} from "@shared/arrays/custom-chatbot-chatbot-for-sales";

export const Head = () => (
  <>
    <html lang="en" />
    <title>Chatbot for sales team — Dashly</title>
    <meta
      name="description"
      content="Grow sales and shorten the cycle with Dashly chatbots. Qualify leads, hand off hot ones, book meetings, work 24/7."
    />
    <Canonical url="https://www.dashly.io/custom-chatbot/chatbot-for-sales/" />
    <Breadcrumbs
      list={[
        { name: "Dashly", url: "https://www.dashly.io/" },
        { name: "Custom chatbot", url: "https://www.dashly.io/custom-chatbot/" },
        {
          name: "Chatbot for sales",
          url: "https://www.dashly.io/custom-chatbot/chatbot-for-sales/",
        },
      ]}
    />
  </>
);

export default function ChatbotForSales() {
  return (
    <Layout className="new-design">
      <RoleLanding
        hero={heroData}
        featuresHeading={featuresHeading}
        features={features}
        comingSoon={comingSoon}
        finalCta={finalCta}
      />
    </Layout>
  );
}
